import { IsNumberString, IsOptional } from 'class-validator';
import { BaseDto } from './base.dto';
import { CartDto } from './cart.dto';
import { DiscountTypeDto } from './discountType.dto';
import { MerchantDto } from './merchant.dto';
import { MerchantSaleUnitDto } from './merchantSaleUnit.dto';
import { SaleUnitCartSplitDto } from './saleUnitCartSplit.dto';
import { ServiceChargeDto } from './serviceCharge.dto';
import { CartOrderDto } from './cartOrder.dto';

export class SaleUnitCartDto extends BaseDto {
  basketId?: string;

  @IsNumberString()
  status?: number;

  @IsNumberString()
  @IsOptional()
  noPersons?: number;

  discountTypeId?: number;
  serviceChargeId?: number;

  cart?: CartDto;
  merchant?: MerchantDto;
  merchantSaleUnit?: MerchantSaleUnitDto;

  @IsOptional()
  saleUnitCartSplits?: SaleUnitCartSplitDto[];

  discountType?: DiscountTypeDto;
  serviceCharge?: ServiceChargeDto;
  discountTypeAmount?: number;
  serviceChargeAmount?: number;
  totalAmount?: number;
  managerEmployeeId?: number;
  isPrintCheckPrinted?: boolean;
  paidAmount?: number;
  processingFeeAmount?: number;

  cartOrders?: CartOrderDto[];

  // Pos only from MerchantSaleUnitPosDto

  noSplits?: number;
}
